import useDefinedContext from "hooks/useDefinedContext";
import ChartDataActionsContext from "../contexts/ChartDataActionsContext";

function useChartDataActions() {
  return useDefinedContext(ChartDataActionsContext);
}
export default useChartDataActions;
